import React from 'react'
import './FooterBot.css'
function FooterBot() {
    return (
        <div className='container-fluid FooterBot'>
            <div className="row ">
                <span >2021 © Etudiants LLC</span>
            </div>
        </div>
    )
}

export default FooterBot;
